module.exports = __webpack_public_path__ + "img/mbc.a71f23c2.png";